import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import XOctagon from '../assets/icons/feather/X octagon.svg?react';

export function XOctagonIcon(props: SvgIconProps) {
  return <SvgIcon component={XOctagon} inheritViewBox {...props} />;
}
